import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mb-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mb-skeleton.component.html',
  styleUrls: ['./mb-skeleton.component.css'],
})
export class MbSkeletonComponent {
  @Input() rows = 6;
  @Input() columns = 9;
  @Input() rowHeight = 'h-4';
  @Input() rowSpacing = 'space-y-3';
  @Input() containerClass = 'w-full';
  @Input() rowClass =
    'flex items-center space-x-4 p-4 border border-gray-200 rounded';

  get skeletonRows(): number[] {
    return Array.from({ length: this.rows }, (_, i) => i + 1);
  }

  get skeletonColumns(): number[] {
    return Array.from({ length: this.columns }, (_, i) => i + 1);
  }

  getColumnWidth(columnIndex: number): string {
    // Default column widths - can be customized per column
    const widths = [
      'w-8',
      'w-24',
      'w-20',
      'w-32',
      'w-16',
      'w-20',
      'w-28',
      'w-20',
      'w-4',
    ];
    return widths[columnIndex - 1] || 'w-20'; // Default to w-20 if no specific width defined
  }
}
